<template>
	<div class="recite_book_contain ptrl-22-15-17">
    <div class="list_every pd-20-22-26  box-s">
      <div class="hp_100" :style="{ 'max-height': height }">
        <div class="fz-22 fw-600 c0 ">{{data.word}}</div>
        <div class="flexs mb-14 mt-14 fz-14 fw-600 c3">
          <div class="">英 {{data.english_phonetic}}</div>
          <div class="ml-24">美 {{data.american_phonetic}}</div>
        </div>
        
        <div class="" >
          <!-- 动词 -->
          <div class="flex pr mb-21" v-if="data.v">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">v.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.v}}</div>
          </div>
          <!-- 名词 -->
          <div class="flex pr mb-21" v-if="data.n">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">n.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.n}}</div>
          </div>

          <!-- 代词 -->
          <div class="flex pr mb-21" v-if="data.pron">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">pron.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.pron}}</div>
          </div>

          <!-- 形容词 -->
          <div class="flex pr mb-21" v-if="data.adj">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">adj.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.adj}}</div>
          </div>

          <!-- 副词 -->
          <div class="flex pr mb-21" v-if="data.adv">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">adv.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.adv}}</div>
          </div>

          <!-- 数词 -->
          <div class="flex pr mb-21" v-if="data.num">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">num.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.num}}</div>
          </div>

          <!-- 冠词 -->
          <div class="flex pr mb-21" v-if="data.art">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">art.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.art}}</div>
          </div>

          <!-- 介词 -->
          <div class="flex pr mb-21" v-else-if="data.prep">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">prep.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.prep}}</div>
          </div>

          <!-- 连词 -->
          <div class="flex pr mb-21" v-if="data.conj">
            <div class="fz-12 fw-600 c2 w25 l-h-12 mt-2">conj.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.conj}}</div>
          </div>

          <!-- 感慨词 -->
          <div class="flex pr" v-if="data.int">
            <div class="fz-12 fw-600 c2 w30 l-h-12 mt-2">int.</div>
            <div class="blue_cicle_4 position_re"></div>
            <div class="ml-16 flex1 fz-14 c1">{{data.int}}</div>
          </div>
        </div>

      </div>

    </div>
    

    <div class="btn_contain">
      <div class="blue_btn" @click="recite">
        我记住了
      </div>
    </div>
		<load :loadFlag="loadFlag"></load>
	</div>
</template>
<script>
	import load from "@/components/loading"
	import { studyEnglishWord } from '@/api/api.js'
	// let isDev = process.env.NODE_ENV == "development";
	import wx from "weixin-js-sdk";
  import {getShowPadding, diffPadd} from "@/utils/common.js";
	export default {
		components: {
      load
		},
		data() {
			return {
        height: '',
        padShow: false,
        id: '',
        data: {},
        page: 1,
        loadFlag: false
			};
		},
		created() {
      this.initData()
		},
		methods: {
      async initData(word_id){
        this.loadFlag = true
        const res = await studyEnglishWord({ plan_id: this.$route.query.plan_id, word_id })
        this.loadFlag = false
        if(res.code == 1000){
          this.data = res.data
          this.id = this.data.id
          if(this.data.is_study_accomplish){
            this.$router.replace('/calendar')
          }
        }else {
					 this.$toast(res.msg)
				}
      },
      recite(){
        this.page = this.page + 1
        this.initData(this.id)
        
      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.height = (document.body.clientHeight - (diffPadd() + 130 + Number((getShowPadding()? 30 : 0))) * (document.documentElement.clientWidth / 375)) + 'px'
      })
    }
	};
</script>
<style lang="less" scoped>
.position_re {
  position: absolute;
  top: 6px;
  left: 35px;
}

.hp_100 {
  overflow: auto;
}


.hp_100::-webkit-scrollbar{
    display: none;
}

</style>
